import React from 'react';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ServiceHero = ({ service, onConsultationClick }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 via-white to-secondary/5 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3 text-primary">
              <Icon name={service.icon} size={24} />
              <span className="text-sm font-semibold uppercase tracking-wide">
                {service.category}
              </span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              {service.title}
            </h1>
            
            <p className="text-xl text-muted-foreground leading-relaxed">
              {service.description}
            </p>
            
            <div className="flex flex-wrap gap-3">
              {service.keyBenefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-2 bg-white rounded-full px-4 py-2 shadow-soft">
                  <Icon name="Check" size={16} className="text-success" />
                  <span className="text-sm font-medium text-foreground">{benefit}</span>
                </div>
              ))}
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                variant="default" 
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                onClick={onConsultationClick}
              >
                Schedule Consultation
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="Download"
                iconPosition="left"
              >
                Download Service Brief
              </Button>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-elevation">
              <Image 
                src={service.heroImage}
                alt={`${service.title} visualization`}
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-elevation p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center">
                  <Icon name="TrendingUp" size={24} color="white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-foreground">{service.successRate}</div>
                  <div className="text-sm text-muted-foreground">Success Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;